import React, { Component } from 'react';
import Page from '../../components/Page/Page';
import SideImage from '../../components/SideImage/SideImage';
import NextPage from '../../components/NextPage/NextPage';

class PageExhibitManagement extends Component {

  render() {
    return (
        <Page primaryTitle="Services" secondaryTitle="Exhibit Management" section="services">
            <div className="col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3 pageExhibitManagement">
                <p className="intro">Owning an exhibit is like owning a car - it requires maintenance and care to keep it in top form. And, sometimes, you just have to trade that old Chevy in on a newer model! SLA Service Management is here to provide the TLC that is necessary to keep your exhibit looking it's best. And, when it's time to trade in that old Chevy, we're here to design and build an exhibit to make your company shine!</p>

                <h3>Warehousing</h3>
                <p>Where you choose to store your exhibit, in relation to your tradeshow calendar, can result in substantial savings in shipping-related costs. In addition to local warehouse space to store and take the greatest care of your exhibit properties, SLA Service Management has warehouse facilities in strategic locations throughout the United States to provide a ’rest stop” for your exhibit while it travels from tradeshow to tradeshow.</p>

                <h3>Repairs &amp; Refurbs</h3>
                <p>SLA Service Management will inspect your exhibit prior to each show to ensure it looks it's best so that you look your best! SLA can repair those normal wear and tear items or reburb a tired, out-of-date exhibit to reflect the latest in design and structure innovation. Not only can a refurb rejuvenate an old exhibit, it can lead to savings in labor, shipping and material handling costs.</p>

                <h3>Builds</h3>
                <p>Aside from reflecting the latest in design and technical innovation, your exhibit needs to be practical. There are many factors that SLA will consider in the design and build of your new exhibit. Do you showcase heavy machinery? Do you have media presentations? Do you showcase a lot of product? Do you use labor to install your exhibit or are you a do-it-yourselfer? The answers to these questions and many more will help SLA to refine the design and build of your exhibit to meet your needs perfectly. It doesn't matter if it's a bannerstand or a 20x30 custom; SLA will deliver a product that provides total customer satisfaction.</p>

                <h3>Other Management</h3>
                <p>Whether it's the management of a small off-site meeting for ten people or a National Sales Meeting with 500 attendees &ndash; SLA can help you to shine!</p>
            
                <NextPage page={this.props.page}/>
            </div>
            <aside className="col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9 sidebar">
                <SideImage page={this.props.page} />
            </aside>
        </Page>
    );
  }
}

export default PageExhibitManagement;



// WEBPACK FOOTER //
// ./src/pages/PageExhibitManagement/PageExhibitManagement.js